<div class="container-fluid p-0" style="height:70px;">
    <img src="../../../../assets/images/logo-clearramp-release.png" style="height:50px;" class="m-2 ml-3">
</div>
<div class="container-fluid">
    <div class="card mb-3">
        <div class="card-body">
            <p class="mb-0">Here you can read about our most recent updates, if you have any feedback and or feature request please use the support page.</p>
        </div>
    </div>
    <div class="card">
      <div class="card-body">
          <h2>Relase notes - 1.2.9</h2>
          <p class="mb-0"><b>(1) Improvement - general hardening and improvements</b></p>
          <p>1/ 1 - Image handling improvements</p>
          <p>1/ 2 - Loading handling improvements</p>
          <p>1/ 3 - Session and access mangement </p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.8</h2>
          <p class="mb-0"><b>(1) Improvement - appliaction overall updates</b></p>
          <p>1/ 1 - Image handling improvements</p>
          <p>1/ 2 - Loading handling improvements</p>
          <p>1/ 3 - Session and access mangement </p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.7</h2>
          <p class="mb-0"><b>(1) Improvement - application security and access</b></p>
          <p>1/ 1 - This update delivers improvements to the appliactions security and access. 
          </p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.6</h2>
          <p class="mb-0"><b>(1) Improvement - Further image handling optimization</b></p>
          <p>1/ 1 - This update delivers improvements to the appliactions image loader setup, required memory. 
          </p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.5</h2>
          <p class="mb-0"><b>(1) Improvement - Loaders and image load time optimization</b></p>
          <p>1/ 1 - This update delivers improvements to the appliactions image loader setup. 
          </p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.4</h2>
          <p class="mb-0"><b>(1) Improvement - Loaders and load time optimization</b></p>
          <p><b>(2) Fixes - Chat issues and file management</b></p>
          <p>1/ 1 - This update delivers improvements to the appliactions loader setup. 
          </p>
          <p>1/ 2 - This update delivers improvements to the load time when navigating the application. 
          </p>
          <p>2/ 1 - Chat persistance is fixed</p>
          <p>2/ 1 - File management is fixed</p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.3</h2>
          <p class="mb-0"><b>(1) Improvement - Added improved error and bug tracking.</b></p>
          <p><b>(2) Fixes - Temporary removeval and additions.</b></p>
          <p>1/ 1 - This update delivers improvements to the appliactions ability to track bugs. 
          </p>
          <p>1/ 2 - This update delivers improvements to the responsive aspect of the application between devices. 
          </p>
          <p>2/ 1 - Userview is removed, to be returned.</p>
          <p>2/ 1 - Filetype restrictions improved.</p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.2</h2>
          <p class="mb-0"><b>(1) Improvement - improved small screen format experience and mobile interaction. </b></p>
          <p><b>(2) Fixes - Added</b></p>
          <p>1/ 1 - This update delivers improvements to the appliaction on small screen formats. 
          </p>
          <p>2/ 1 - This update delivers performance increase to the appliaction. 
          </p>
          <p>1/ 2 - This update delivers improvements to touch interaction. 
          </p>
          <p>1/ 3 - Added new update to the responsive nature of the application. 
          </p>
          <p>2/ 1 - Project edit alert box appearing on edit fixed.</p>
          <p>3/ 1 - Project sorting on portal is changed.</p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.1</h2>
          <p class="mb-0"><b>(1) Improvement - improved load times. </b></p>
          <p><b>(2) Fixes - Added current version to debug customer issues.</b></p>
          <p>1/ 1 - This update delivers fixes to the login flow load times. 
          </p>
          <p>2/ 1 - Support link fixed.</p>
      </div>
  </div>
    <div class="card mt-2">
      <div class="card-body">
          <h2>Relase notes - 1.2.0</h2>
          <p class="mb-0"><b>(1) Improvement - Added tooltips, helpers, loaders and improved assignment flow. </b></p>
          <p><b>(2) Fixes - Added validation and loaders to various work flows and various fixes.</b></p>
          <p>1/ 1 - This update delivers fixes to the translation provided by the system and adds new translation where needed. 
          </p>
          <p>1/ 2 - Tooltips and helpers to guide users creating new projects and managing existing projects.</p>
          <p>1/ 3 - Creating projects flow is improved, ensuring the optimal experience.</p>
          <p>2/ 1 - Duplicate items issue fixed.</p>
          <p>2/ 2 - Assign roles issues fixed and clarity is improved.</p>
      </div>
  </div>
    <div class="card mt-2">
        <div class="card-body">
            <h2>Relase notes - 1.1.0</h2>
            <p class="mb-0"><b>(1) Features - Added 4 new languages</b></p>
            <p class="mb-0"><b>(2) Improvement - Added tooltips and helpers</b></p>
            <p><b>(3) Fixes - Added validation to project creation flow</b></p>
            <p>1/ This update enables our users to use our system with 5 diffrent languages, a organization standard language can be set and users can then customise if needed:<br>
                - Danish<br>
                - Swedish<br>
                - Norwegian<br>
                - Finnish<br>
                - English<br>
            </p>
            <p>2/ Tooltips and helpers to guide users creating new projects and managing existing projects.</p>
            <p>3/ Validation has been added to all appropriate forms that facilitate projects, stages and tasks.</p>
        </div>
    </div>
</div>
<div style="position: fixed; bottom:0px; left:0px;" class="container-fluid pt-4 bg-secondary">
    <div class="row">
      <div class="col">
        <img src="../../../../assets/images/logo-clearramp-release.png" height="25px" class="mb-3">
      </div>
      <div class="col">
        <p>ClearRamp © 2024</p>
      </div>
      <div class="col d-inline">
        <a class="cursor-pointer" routerLink="/"><p class="d-inline cursor-pointer">Back to application</p></a>
        <p class="d-inline"> - </p>
        <a class="cursor-pointer" routerLink="/support"><p class="d-inline cursor-pointer">Support</p></a>
      </div>
    </div>
  </div>
